module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_vm._m(0), _vm._v(" "), (_vm.login.loggedIn) ? _c('div', {
    staticClass: "title-panel"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h2', [_vm._v("Cantonniers, " + _vm._s(_vm.currentVille.name))]), _vm._v(" "), _c('hr')])]) : _vm._e(), _vm._v(" "), _c('sidebar-menu')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "/"
    }
  }, [_c('div', {
    staticClass: "logo-lg"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/suez-white.png",
      "alt": "Logo"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1012bf2e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 2081
// module chunks = 2